import * as Actions from '../../../redux/actions'

import React, { Component } from 'react'

import { connect, useDispatch, useSelector } from 'react-redux'
import { useParams, useLocation } from 'react-router-dom';
import { ScrollTopLazyLoading } from '../Common/ScrollTopLazyLoading';
import { Backdrop, CircularProgress, Fab, Grid, makeStyles } from '@material-ui/core';
import { AngleUpIcon } from '../Common/SVGBank';
import { useHistory } from "react-router-dom";
import moment from 'moment';
import Loader from 'react-loader-spinner'
import { lookUpHotelThunk, CancelHotelThunk } from '../BookingPage/PaymentPage/payment.thunk';
import { HotelBookingStatus, HotelBookingSupport, HotelConfirmationDetails, HotelDetails } from "./MuvManagementComponent"
import { HotelRoomList } from './MuvManagementList';
import { HotelPaymentDetails, MuvPaymentDetails } from './MuvPaymentDetails';
import { CancelExpediaBooking, GetExpediaBooking } from '../MuvPaymentPage/muvMeta.services';
import Confirmation from '../Common/model/Confirmation'

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));


const MuvManagementContainer_ = ({ lang, uuid, bodyClientWidth, pageYOffset, is_mobile, timelineWizardStatus, activeTrip }) => {
    const search = useLocation().search;
    const query = new URLSearchParams(search);
    let booking_id = query.get('booking_id');
    let imageUrl = query.get('imageUrl');

    const classes = useStyles();
    const history = useHistory();

    const activeTripId = activeTrip?.tripId;
    let width;
    let marginLeft;
    const [saveToTrip, setSaveToTrip] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [bookingFlight, setBookFlight] = React.useState(false);
    const [isConfirmationOpen, setIsConfirmationOpen] = React.useState(false)

    var searchParams = new URLSearchParams(document.location.search.substring(1));
    const email = searchParams.get("email")
    const affiliateId = searchParams.get("affiliateId")
    const [expediaDetails, setExpediaDetails] = React.useState()
    const isExpedia = !!(expediaDetails?.affiliate_reference_id)




    React.useEffect(() => {
        if (email && affiliateId) {
            fetchBooking()

        }
    }, [email, affiliateId])


    let positionScrollToTopLazyLoading = ""
    if (!isNaN(is_mobile)) {
        width = is_mobile ? '100%' : '60%';
        marginLeft = is_mobile ? '0%' : timelineWizardStatus ? '31%' : '23%';
        positionScrollToTopLazyLoading = is_mobile ? "" : (timelineWizardStatus ? "10%" : "10%")
    }
    const dispatch = useDispatch()

    const fetchBooking = async () => {
        const result = await GetExpediaBooking(email, affiliateId)
        setExpediaDetails(result?.result?.[0]);
        setLoading(false)
    }


    const lookUpData = useSelector(state => state.HotelBooking.lookUpData);

    const authModal = useSelector(state => state.Member.authModal);


    const cancelHotel = async () => {
        setLoading(true)
        const res = await CancelExpediaBooking(email, affiliateId);
        fetchBooking()
    }

    const handleCancelClick = () => {
        setIsConfirmationOpen(true)
    }

    const handleConfirmationClose = () => {
        setIsConfirmationOpen(false)
    }

    const handleConfirmationConfirm = () => {
        setIsConfirmationOpen(false)
        cancelHotel()
    }


    const customer = lookUpData?.itinerary_details?.customer;
    const hotel = lookUpData?.hotel;
    const itinerary = lookUpData?.itinerary;
    const itinerary_details = lookUpData?.itinerary_details;
    const cancellation_details = lookUpData?.cancellation_details;
    const allowCancel = lookUpData?.actions?.cancel;
    const price_details = lookUpData?.price_details;
    const important_information = lookUpData?.important_information;
    const booking_status = lookUpData?.itinerary?.status && lookUpData?.itinerary?.status === "Cancelled" ? "cancelled" : "confirmed";
    const expediaHotelDetails = isExpedia ? expediaDetails?.hotel_data : null;

    const isBookedExpedia = expediaDetails?.rooms?.[0]?.status === "booked"
    return (
        <div>
            {loading ? <Loader
                type="Rings"
                color="#19BC9B"
                className="se-pre-con"
                height={150}
                width={150}
                style={{
                    backgroundColor: "#FFFFFF"
                }} /> :
                <div>
                    <div style={{
                        position: "relative",
                        width: width,
                        marginLeft: marginLeft,
                        paddingBottom: 50,
                        marginTop: 50
                    }}>
                        <div id="back_to_top_flights"></div>

                        <Grid container className="flightRecap">

                            {<HotelBookingStatus hotelName={expediaHotelDetails?.property_name ?? hotel?.hotel_name} booking_status={isBookedExpedia ? "confirmed" : "cancelled"} />}

                            {<HotelDetails hotel={expediaHotelDetails ?? hotel} imageUrl={expediaHotelDetails?.photo_data?.[0]} hotelPhone={expediaDetails?.phone?.number} />}

                            {<HotelConfirmationDetails is_mobile={is_mobile} itinerary={itinerary} itinerary_details={itinerary_details}
                                hotel={expediaDetails ?? hotel} />}


                            {<HotelRoomList itinerary_details={itinerary_details}
                                isBookedExpedia={isBookedExpedia}
                                hotel={expediaDetails ?? hotel} cancellation_details={cancellation_details} booking_status={booking_status}
                                cancelHotel={handleCancelClick} allowCancel={allowCancel || isBookedExpedia} />}

                            {lookUpData && <MuvPaymentDetails lookUpData={lookUpData} is_mobile={is_mobile} />}
                            {lookUpData && <HotelBookingSupport lookUpData={lookUpData} />}
                        </Grid>
                        <Backdrop className={classes.backdrop} open={bookingFlight} >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    </div>

                    <Confirmation
                        isConfirmationOpen={isConfirmationOpen}
                        closeConfirmation={handleConfirmationClose}
                        confirmationTitle="Cancel Hotel Booking"
                        confirmationMessage="Are you sure you want to cancel this hotel booking? This action cannot be undone."
                        handleConfirmation={handleConfirmationConfirm}
                    />

                    <ScrollTopLazyLoading targetId={"#back_to_top_flights"} rightPosition={positionScrollToTopLazyLoading}>
                        <Fab size="small" aria-label="scroll back to top" style={{
                            outline: "0px",
                            backgroundColor: '#19BC9B',
                        }}>
                            <AngleUpIcon fill={"var(--mainWhite)"} style={{ marginLeft: "3px" }} />
                        </Fab>
                    </ScrollTopLazyLoading>
                </div>}

        </div>
    )
}


const mapStateToProps = state => {
    return {
        lang: state.Setting.lang,
        activeTrip: state.FormBank.TimelineWizard.activeTrip,
        is_mobile: state.Setting.is_mobile,
        lazyLoading: state.FormBank.HotelSearch.lazyLoading,
        hotelSearchForm: state.FormBank.HotelSearch.hotel_form_state,
        bookingForm: state.FormBank.BookingForm,
        bodyClientWidth: state.Setting.htmlBody.bodyClientWidth,
        pageYOffset: state.Setting.screenVertical.pageYOffset,
        switchFeatureContainer: state.FormBank.FeatureFormat,
        timelineWizardStatus: state.FormBank.TimelineWizard.status,
        uuid: state.Member.authModal.uuid,
    }
}

const mapDispatchToProps = {
    setTripDisplayMode: Actions.setTripDisplayMode,
    setPageYOffset: Actions.setPageYOffset
}

const MuvManagementContainer = connect(mapStateToProps, mapDispatchToProps)(MuvManagementContainer_)
export default MuvManagementContainer
